import { Button, cn } from '@heroui/react';
import { IconFileText, IconX } from '@tabler/icons-react';

export type AiChatAttachmentListItem = {
  id?: string;
  mimeType?: string;
  name: string;
  src?: string;
};

export type AiChatAttachmentListProps = {
  attachments: readonly AiChatAttachmentListItem[];
  className?: string;
  removeLabel?: string;
  onRemove?: (attachment: AiChatAttachmentListItem) => void;
};

function isImageAttachment(attachment: AiChatAttachmentListItem) {
  return Boolean(attachment.src && attachment.mimeType?.startsWith('image/'));
}

export function AiChatAttachmentList({
  attachments,
  className,
  onRemove,
  removeLabel = '移除附件',
}: AiChatAttachmentListProps) {
  if (!attachments.length) return null;

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      {attachments.map((attachment, index) => (
        <div
          key={attachment.id ?? `${attachment.name}-${index}`}
          className="border-border bg-default/60 text-foreground flex h-10 min-w-0 max-w-64 items-center gap-2 rounded-lg border px-1.5 pr-2"
        >
          {isImageAttachment(attachment) ? (
            <img alt="" className="size-7 shrink-0 rounded-md object-cover" src={attachment.src} />
          ) : (
            <span className="bg-background text-muted flex size-7 shrink-0 items-center justify-center rounded-md">
              <IconFileText className="size-4" stroke={1.75} />
            </span>
          )}
          <span className="min-w-0 flex-1 truncate text-sm">{attachment.name}</span>
          {onRemove ? (
            <Button
              isIconOnly
              aria-label={`${removeLabel}: ${attachment.name}`}
              className="-mr-1 size-6 min-w-6"
              size="sm"
              variant="ghost"
              onPress={() => onRemove(attachment)}
            >
              <IconX className="size-3.5" stroke={1.75} />
            </Button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
